import request from '@/utils/request'


// 查询调查问卷选项列表
export function listSurveyProblem(query) {
  return request({
    url: '/biz/survey-problem/list',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项分页
export function pageSurveyProblem(query) {
  return request({
    url: '/biz/survey-problem/page',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项详细
export function getSurveyProblem(data) {
  return request({
    url: '/biz/survey-problem/detail',
    method: 'get',
    params: data
  })
}

// 新增调查问卷选项
export function addSurveyProblem(data) {
  return request({
    url: '/biz/survey-problem/add',
    method: 'post',
    data: data
  })
}

// 修改调查问卷选项
export function updateSurveyProblem(data) {
  return request({
    url: '/biz/survey-problem/edit',
    method: 'post',
    data: data
  })
}

// 删除调查问卷选项
export function delSurveyProblem(data) {
  return request({
    url: '/biz/survey-problem/delete',
    method: 'post',
    data: data
  })
}
